import { styled } from '@mui/material/styles';

export const StyledZenModeWrapper = styled('div')(({ theme, isZenMode }) => ({
  alignItems: 'center',
  justifyContent: 'flex-start',
  maxWidth: '145px',
  width: '100%',
  height: '40px',
  borderRadius: '20px 0px 0px 20px',
  background: theme.palette.generic.sysaid_mid,
  display: isZenMode ? 'flex' : 'none',
  flexDirection: 'row',
  marginLeft: 'auto',
  padding: '0px 5px',
  '.zen-mode-icon': {
    width: '28px',
    height: '28px',
  },
  '.zen-refresh-icon': {
    marginLeft: 'auto',
    marginRight: '10px',
  },
}));

export const StyledText = styled('span')({
  paddingLeft: '6px',
  paddingRight: '12px',
  fontSize: '13px',
});
